var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "v-app",
    [
      _c(
        "v-row",
        {
          attrs: {
            justify: "center"
          }
        },
        [
          _c(
            "v-col",
            {
              attrs: {
                cols: "12",
                md: "6"
              }
            },
            [
              _c(
                "v-card",
                {
                  staticClass: "app-card"
                },
                [
                  _c(
                    "v-card-text",
                    [
                      _c(
                        "v-row",
                        {
                          staticClass: "px-3"
                        },
                        [
                          _c(
                            "v-col",
                            {
                              staticClass: "text-center",
                              attrs: {
                                cols: "12"
                              }
                            },
                            [
                              _c("img", {
                                staticClass: "img-responsive mb-3",
                                attrs: {
                                  src: _vm.logotype,
                                  alt: "Logotype"
                                }
                              }),
                              _c("br"),
                              _c("br"),
                              _c(
                                "h1",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: !_vm.loadingValidate,
                                      expression: "!loadingValidate"
                                    }
                                  ],
                                  staticClass:
                                    "font-weight-bold primary--text mb-0"
                                },
                                [
                                  _vm._v(
                                    " Join " +
                                      _vm._s(_vm.invitedBy) +
                                      " on GreenGeeks "
                                  )
                                ]
                              )
                            ]
                          ),
                          _c(
                            "v-col",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.loadingValidate,
                                  expression: "loadingValidate"
                                }
                              ],
                              staticClass: "text-center",
                              attrs: {
                                cols: "12"
                              }
                            },
                            [
                              _c("v-progress-circular", {
                                attrs: {
                                  indeterminate: "",
                                  size: "64",
                                  color: "primary"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-col",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: !_vm.loadingValidate,
                                  expression: "!loadingValidate"
                                }
                              ],
                              attrs: {
                                cols: "12"
                              }
                            },
                            [
                              _c(
                                "v-row",
                                [
                                  _c(
                                    "v-col",
                                    {
                                      staticClass: "text-center",
                                      attrs: {
                                        cols: "12"
                                      }
                                    },
                                    [
                                      _c(
                                        "p",
                                        {
                                          staticClass: "mb-0"
                                        },
                                        [
                                          _vm._v(
                                            " You have been invited to join " +
                                              _vm._s(_vm.invitedBy) +
                                              "'s account. Please fill out the form below to create your account. "
                                          )
                                        ]
                                      )
                                    ]
                                  ),
                                  _c(
                                    "v-col",
                                    {
                                      attrs: {
                                        cols: "12"
                                      }
                                    },
                                    [
                                      _c(
                                        "span",
                                        {
                                          staticClass:
                                            "subtitle-1 font-weight-bold"
                                        },
                                        [_vm._v("Account Information")]
                                      ),
                                      _c("v-divider")
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _c(
                                "v-form",
                                {
                                  staticClass: "gg-inv-form",
                                  attrs: {
                                    autocomplete: "off"
                                  }
                                },
                                [
                                  _c(
                                    "v-row",
                                    [
                                      _c(
                                        "v-col",
                                        {
                                          staticClass: "py-0",
                                          attrs: {
                                            cols: "12",
                                            md: "6"
                                          }
                                        },
                                        [
                                          _c("label", [_vm._v("E-mail")]),
                                          _c("v-text-field", {
                                            directives: [
                                              {
                                                name: "validate",
                                                rawName: "v-validate",
                                                value: "required|email",
                                                expression: "'required|email'"
                                              }
                                            ],
                                            attrs: {
                                              outlined: "",
                                              dense: "",
                                              disabled: "",
                                              autocomplete: "off",
                                              "data-vv-name": "email",
                                              "data-vv-as": "Email",
                                              "error-messages": _vm.errors.collect(
                                                "email"
                                              )
                                            },
                                            model: {
                                              value: _vm.model.email,
                                              callback: function callback($$v) {
                                                _vm.$set(
                                                  _vm.model,
                                                  "email",
                                                  typeof $$v === "string"
                                                    ? $$v.trim()
                                                    : $$v
                                                )
                                              },
                                              expression: "model.email"
                                            }
                                          })
                                        ],
                                        1
                                      ),
                                      _c(
                                        "v-col",
                                        {
                                          staticClass: "py-0",
                                          attrs: {
                                            cols: "12",
                                            md: "6"
                                          }
                                        },
                                        [
                                          _c(
                                            "v-row",
                                            [
                                              _c(
                                                "v-col",
                                                {
                                                  staticClass: "py-0",
                                                  attrs: {
                                                    cols: "12"
                                                  }
                                                },
                                                [
                                                  _c("label", [
                                                    _vm._v("Phone Number")
                                                  ])
                                                ]
                                              ),
                                              _c(
                                                "v-col",
                                                {
                                                  staticClass: "py-0",
                                                  attrs: {
                                                    cols: "5"
                                                  }
                                                },
                                                [
                                                  _c("v-combobox", {
                                                    attrs: {
                                                      outlined: "",
                                                      dense: "",
                                                      name: "suffix",
                                                      autocomplete: "suffix",
                                                      "auto-select-first": "",
                                                      items: _vm.dialCodes
                                                    },
                                                    model: {
                                                      value: _vm.phone.dialCode,
                                                      callback: function callback(
                                                        $$v
                                                      ) {
                                                        _vm.$set(
                                                          _vm.phone,
                                                          "dialCode",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "phone.dialCode"
                                                    }
                                                  })
                                                ],
                                                1
                                              ),
                                              _c(
                                                "v-col",
                                                {
                                                  staticClass: "py-0",
                                                  attrs: {
                                                    cols: "7"
                                                  }
                                                },
                                                [
                                                  _c("v-text-field", {
                                                    directives: [
                                                      {
                                                        name: "validate",
                                                        rawName: "v-validate",
                                                        value: "required",
                                                        expression: "'required'"
                                                      }
                                                    ],
                                                    attrs: {
                                                      outlined: "",
                                                      dense: "",
                                                      "data-vv-name":
                                                        "phonenumber",
                                                      "data-vv-as":
                                                        "Phone Number",
                                                      "error-messages": _vm.errors.collect(
                                                        "phonenumber"
                                                      )
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.phone.phonenumber,
                                                      callback: function callback(
                                                        $$v
                                                      ) {
                                                        _vm.$set(
                                                          _vm.phone,
                                                          "phonenumber",
                                                          typeof $$v ===
                                                            "string"
                                                            ? $$v.trim()
                                                            : $$v
                                                        )
                                                      },
                                                      expression:
                                                        "phone.phonenumber"
                                                    }
                                                  })
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  ),
                                  _c(
                                    "v-row",
                                    [
                                      _c(
                                        "v-col",
                                        {
                                          attrs: {
                                            cols: "12",
                                            md: "6"
                                          }
                                        },
                                        [
                                          _c("label", [_vm._v("First Name")]),
                                          _c("v-text-field", {
                                            directives: [
                                              {
                                                name: "validate",
                                                rawName: "v-validate",
                                                value: "required",
                                                expression: "'required'"
                                              }
                                            ],
                                            attrs: {
                                              outlined: "",
                                              dense: "",
                                              "data-vv-name": "firstname",
                                              "data-vv-as": "First Name",
                                              autocomplete: "new-password",
                                              "error-messages": _vm.errors.collect(
                                                "firstname"
                                              )
                                            },
                                            model: {
                                              value: _vm.model.firstname,
                                              callback: function callback($$v) {
                                                _vm.$set(
                                                  _vm.model,
                                                  "firstname",
                                                  typeof $$v === "string"
                                                    ? $$v.trim()
                                                    : $$v
                                                )
                                              },
                                              expression: "model.firstname"
                                            }
                                          })
                                        ],
                                        1
                                      ),
                                      _c(
                                        "v-col",
                                        {
                                          attrs: {
                                            cols: "12",
                                            md: "6"
                                          }
                                        },
                                        [
                                          _c("label", [_vm._v("Last Name")]),
                                          _c("v-text-field", {
                                            directives: [
                                              {
                                                name: "validate",
                                                rawName: "v-validate",
                                                value: "required",
                                                expression: "'required'"
                                              }
                                            ],
                                            attrs: {
                                              outlined: "",
                                              dense: "",
                                              "data-vv-name": "lastname",
                                              "data-vv-as": "Last Name",
                                              autocomplete: "new-password",
                                              "error-messages": _vm.errors.collect(
                                                "lastname"
                                              )
                                            },
                                            model: {
                                              value: _vm.model.lastname,
                                              callback: function callback($$v) {
                                                _vm.$set(
                                                  _vm.model,
                                                  "lastname",
                                                  typeof $$v === "string"
                                                    ? $$v.trim()
                                                    : $$v
                                                )
                                              },
                                              expression: "model.lastname"
                                            }
                                          })
                                        ],
                                        1
                                      ),
                                      _c(
                                        "v-col",
                                        {
                                          attrs: {
                                            cols: "12",
                                            md: "6"
                                          }
                                        },
                                        [
                                          _c("label", [_vm._v("Password")]),
                                          _c("v-text-field", {
                                            directives: [
                                              {
                                                name: "validate",
                                                rawName: "v-validate",
                                                value: "required|min:6",
                                                expression: "'required|min:6'"
                                              }
                                            ],
                                            ref: "password",
                                            attrs: {
                                              outlined: "",
                                              dense: "",
                                              type: "password",
                                              "data-vv-name": "password",
                                              "data-vv-as": "Password",
                                              autocomplete: "new-password",
                                              "error-messages": _vm.errors.collect(
                                                "password"
                                              )
                                            },
                                            model: {
                                              value: _vm.model.password,
                                              callback: function callback($$v) {
                                                _vm.$set(
                                                  _vm.model,
                                                  "password",
                                                  $$v
                                                )
                                              },
                                              expression: "model.password"
                                            }
                                          })
                                        ],
                                        1
                                      ),
                                      _c(
                                        "v-col",
                                        {
                                          attrs: {
                                            cols: "12",
                                            md: "6"
                                          }
                                        },
                                        [
                                          _c("label", [
                                            _vm._v("Confirm Password")
                                          ]),
                                          _c("v-text-field", {
                                            directives: [
                                              {
                                                name: "validate",
                                                rawName: "v-validate",
                                                value:
                                                  "required|confirmed:password",
                                                expression:
                                                  "'required|confirmed:password'"
                                              }
                                            ],
                                            attrs: {
                                              outlined: "",
                                              dense: "",
                                              type: "password",
                                              "data-vv-name": "passwordconfirm",
                                              "data-vv-as": "Confirm Password",
                                              autocomplete: "new-password",
                                              "error-messages": _vm.errors.collect(
                                                "passwordconfirm"
                                              )
                                            },
                                            model: {
                                              value: _vm.model.passwordconfirm,
                                              callback: function callback($$v) {
                                                _vm.$set(
                                                  _vm.model,
                                                  "passwordconfirm",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "model.passwordconfirm"
                                            }
                                          })
                                        ],
                                        1
                                      ),
                                      _c(
                                        "v-col",
                                        {
                                          attrs: {
                                            cols: "12"
                                          }
                                        },
                                        [
                                          _c(
                                            "v-row",
                                            {
                                              attrs: {
                                                justify: "center"
                                              }
                                            },
                                            [
                                              _c("v-checkbox", {
                                                directives: [
                                                  {
                                                    name: "validate",
                                                    rawName: "v-validate",
                                                    value: "required:true",
                                                    expression:
                                                      "'required:true'"
                                                  }
                                                ],
                                                attrs: {
                                                  "data-vv-name": "agreement",
                                                  "data-vv-as":
                                                    "Privacy Policy Agreement",
                                                  "error-messages": _vm.errors.collect(
                                                    "agreement"
                                                  )
                                                },
                                                scopedSlots: _vm._u([
                                                  {
                                                    key: "label",
                                                    fn: function fn() {
                                                      return [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "justify-center align-center text-center"
                                                          },
                                                          [
                                                            _vm._v(
                                                              " I confirm that I have read the "
                                                            ),
                                                            _c(
                                                              "a",
                                                              {
                                                                attrs: {
                                                                  target:
                                                                    "_blank",
                                                                  href:
                                                                    "https://www.greengeeks.com/legal/tos"
                                                                },
                                                                on: {
                                                                  click: function click(
                                                                    $event
                                                                  ) {
                                                                    $event.stopPropagation()
                                                                  }
                                                                }
                                                              },
                                                              [
                                                                _vm._v(
                                                                  " Terms and Conditions "
                                                                )
                                                              ]
                                                            ),
                                                            _vm._v(" and the "),
                                                            _c(
                                                              "a",
                                                              {
                                                                attrs: {
                                                                  target:
                                                                    "_blank",
                                                                  href:
                                                                    "https://www.greengeeks.com/legal/privacy"
                                                                },
                                                                on: {
                                                                  click: function click(
                                                                    $event
                                                                  ) {
                                                                    $event.stopPropagation()
                                                                  }
                                                                }
                                                              },
                                                              [
                                                                _vm._v(
                                                                  " Privacy Policy "
                                                                )
                                                              ]
                                                            ),
                                                            _vm._v(". ")
                                                          ]
                                                        )
                                                      ]
                                                    },
                                                    proxy: true
                                                  }
                                                ]),
                                                model: {
                                                  value: _vm.agreement,
                                                  callback: function callback(
                                                    $$v
                                                  ) {
                                                    _vm.agreement = $$v
                                                  },
                                                  expression: "agreement"
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      ),
                                      _c(
                                        "v-col",
                                        {
                                          staticClass: "text-center",
                                          attrs: {
                                            cols: "12"
                                          }
                                        },
                                        [
                                          _c(
                                            "gg-btn",
                                            {
                                              attrs: {
                                                color: "primary",
                                                tile: "",
                                                loading: _vm.loadingRegister
                                              },
                                              on: {
                                                click: _vm.register
                                              }
                                            },
                                            [_vm._v("Continue & Get Access")]
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }